// src/types/Voice.ts
// Note: To add a new voice you must also update the /src/realtime/client.js

export interface Voice {
    name: string;
    value: string;
    gender: string;
    description: string;
}

export const VOICE_OPTIONS: Voice[] = [
    {
        name: 'alloy',
        value: 'alloy',
        gender: 'f',
        description: 'balanced',
    },
    {
        name: 'ash',
        value: 'ash',
        gender: 'm',
        description: 'expressive',
    },
    {
        name: 'ballad',
        value: 'ballad',
        gender: 'f',
        description: 'expressive british',
    },
    {
        name: 'coral',
        value: 'coral',
        gender: 'f',
        description: 'expressive',
    },
    {
        name: 'echo',
        value: 'echo',
        gender: 'm',
        description: 'balanced',
    },
    {
        name: 'sage',
        value: 'sage',
        gender: 'f',
        description: 'expressive gentle',
    },
    {
        name: 'shimmer',
        value: 'shimmer',
        gender: 'f',
        description: 'balanced bright',
    },
    {
        name: 'verse',
        value: 'verse',
        gender: 'm',
        description: 'expressive',
    },
]
